// extracted by mini-css-extract-plugin
module.exports = {"TitleBarRight":"Widgets_TitleBarRight__3B8GT"};